import Login from '../views/CallTaxi/Login';
import DriverList from '../views/Default/Driver/DriverList';
import DriverDetail from '../views/Default/Driver/DriverDetail';
import VehicleList from "../views/Default/Vehicle/VehicleList";
import VehicleDetail from "../views/Default/Vehicle/VehicleDetail";
import VehicleModelList from "../views/Default/Vehicle/VehicleModelList";
import CustomerList from '../views/Default/Customer/CustomerList';
import CustomerDetail from '../views/Default/Customer/CustomerDetail';
import DriveSchedule from '../views/Default/DriveSchedule/DriveSchedule';
import ScheduleDetail from '../views/Default/DriveSchedule/ScheduleDetail';
import ReservationList from "../views/Default/Reservation/ReservationList";
import ReservationDetail from "../views/CallTaxi/Reserve/ReservationDetail";
import CanceledReservationList from "../views/Default/Reservation/CanceledReservationList";
import AdminList from "../views/Default/Admin/AdminList";
import DriveLog from "../views/Default/DriveLog/DriveLog";
import DriveLogDetail from "../views/Default/DriveLog/DriveLogDetail";
import Dashboard from '../views/Default/Dashboard';
import MapMonitoring from '../views/CallTaxi/Map';
import Statistics from "../views/CallTaxi/monitoring/Statistic";
import CanceledReservationDetail from "@/views/CallTaxi/Reserve/CanceledReservationDetail";
import CenterList from "../views/Default/Center/CenterList";
import CenterDetail from '../views/Default/Center/CenterDetail';
import NoticeBoard from "../views/Default/Notice/NoticeBoard";

import LostItemList from "../views/Default/LostItem/LostItemList";
import LostItemDetail from "../views/Default/LostItem/LostItemDetail";

import TermsBoard from "../views/Default/Terms/TermsBoard";
import Terms from "../views/Default/Terms/Terms";
import ReserveReception from "../views/CallTaxi/Reserve/ReserveReception";
import ReserveReceptionBeta from '../views/CallTaxi/Reserve/ReserveReceptionBeta';
import ReserveReceptionQuick from '../views/CallTaxi/Reserve/ReserveReceptionQuick';
import NoticeBoardDetail from "../views/Default/Notice/NoticeBoardDetail";
import NoticeWriter from "../views/Default/Notice/NoticeWriter";

import GroupList from "../views/Default/Group/GroupList";
import GroupDetail from "../views/Default/Group/GroupDetail";
import HardwareList from "../views/Default/Hardware/HardwareList";
import RoleList from "../views/Default/Role/RoleList"
import DeliveryReception from '../views/CallTaxi/Delivery/DeliveryReception'

import DeliveryList from "../views/CallTaxi/Delivery/DeliveryList";
import DeliveryReceptionDone from '../views/CallTaxi/Delivery/DeliveryReceptionDone';
import DeliveryDetail from "@/views/CallTaxi/Delivery/DeliveryDetail";
import DailyReports from "@/views/CallTaxi/monitoring/DailyReports";
import DailyReportsDetail from "@/views/CallTaxi/monitoring/DailyReportsDetail";
import ReceptionsForDriving from "../views/CallTaxi/monitoring/ReceptionsForDriving";
import ReceptionsForDelivery from "../views/CallTaxi/monitoring/ReceptionsForDelivery";
import BusinessLog from '../views/Default/Statistics/BusinessLog';
const routes = [
  {
    path: '/',
    type: 'hidden',
    name: 'Login',
    component: Login,
    meta: {
      keepAlive: false
    },
    beforeEnter: (to, from, next) => {
      window.sessionStorage.removeItem('token');
      window.sessionStorage.removeItem('refreshToken');
      next();
    }
  },
  {
    type: "category",
    name: '모니터링',
    icon: 'public',
    active:true,
    subRoutes: [
      {
        path:'/dashboard',
        type:"menu",
        name: '예약현황',
        icon:'remove',
        component:Dashboard,
        meta: {
          keepAlive: true,
          pageTitle: '일별 예약 현황',

        }
      },
      {
        path:'/monitoring/map',
        type:"menu",
        name: '통합관제',
        icon:'remove',
        component:MapMonitoring,
        meta: {
          keepAlive: false
        }
      },
      {
        path:'/statistics',
        type: "menu",
        name: '통계현황',
        icon:'remove',
        component: Statistics,
        meta: {
          keepAlive: true,
          pageTitle: '통계 현황',
        }
      },
      {
        path:'/dailyReports',
        type:"menu",
        name: '업무일지',
        icon:'remove',
        component: DailyReports,
        meta: {
          keepAlive: true
        }
      },
      {
        path:'/receptions',
        type: "menu",
        name: '접수 기록',
        icon:'remove',
        component: ReceptionsForDriving,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path:'/deliveryReceptions',
    type: "hidden",
    name: '배송 접수 기록',
    icon:'remove',
    component: ReceptionsForDelivery,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/dailyReports/:startDate/:endDate',
    type: 'hidden',
    name: '업무일지 리스트',
    component: DailyReportsDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reserve/:phoneNo',
    type: 'hidden',
    name: '예약 접수',
    component: ReserveReceptionBeta,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reserve/rsv/:reservationId',
    type: 'hidden',
    name: '예약 접수',
    component: ReserveReceptionBeta,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reserve/undo/:canceledReservationId',
    type: 'hidden',
    name: '예약 접수',
    component: ReserveReceptionBeta,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reservetion',
    type: 'menu',
    name: '예약 접수',
    component: ReserveReception,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reservationQuick',
    type: 'menu',
    name: '빠른 예약 접수',
    component: ReserveReceptionQuick,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reservetionBeta',
    type: 'menu',
    name: '예약 접수 Beta',
    component: ReserveReceptionBeta,
    meta: {
      keepAlive: false
    }
  },
  {
    type:"category",
    name: '예약 관리',
    icon:'library_books',
    subRoutes: [
      {
        path: '/reservation',
        type: 'menu',
        name: '예약 내역',
        icon: 'remove',
        component: ReservationList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/canceledReservation',
        type: 'menu',
        name: '취소된 예약 내역',
        icon: 'remove',
        component: CanceledReservationList,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/reservation/:reservationId',
    type: 'hidden',
    name: '예약 상세 정보',
    component: ReservationDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/canceledReservation/:canceledReservationId',
    type: 'hidden',
    name: '취소된 예약 상세 정보',
    component: CanceledReservationDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    type: "category",
    name: '주행 관리',
    icon: 'speed',
    subRoutes: [
      {
        path: '/driveLog',
        type: 'menu',
        name: '주행 내역',
        icon: 'remove',
        component: DriveLog,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/driveLog/:id',
    type: 'hidden',
    name: '주행 상세 정보',
    component: DriveLogDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    type:"category",
    name: '배송 관리',
    icon:'library_books',
    subRoutes: [
      {
        path: '/deliveryReception',
        type: 'menu',
        name: '배송 접수',
        icon: 'remove',
        component: DeliveryReception,
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/delivery',
        type: 'menu',
        name: '배송 내역',
        icon: 'remove',
        component: DeliveryList,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/delivery/reception/done/:id',
    type: 'hidden',
    name: '배송 접수 완료',
    component: DeliveryReceptionDone,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/delivery/:id',
    type: 'hidden',
    name: '배송 상세 정보',
    component: DeliveryDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    type:"category",
    name:'기사 관리',
    icon:'assignment_ind',
    subRoutes:[
      {
        path: '/drivers',
        type: 'menu',
        name: '기사 목록',
        icon: 'remove',
        component: DriverList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/driveSchedule',
        type: 'menu',
        name: '기사 근무 일정',
        icon: 'remove',
        component: DriveSchedule,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/drivers/:driverId',
    type: 'hidden',
    name: '기사 상세 정보',
    component: DriverDetail,
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/driveSchedule/:date',
    type: 'hidden',
    name: '기사 근무 일정 등록',
    component: ScheduleDetail,
    meta: {
      keepAlive: false
    }
  },

  {
    type:"category",
    name:'차량 관리',
    icon:'local_taxi',
    subRoutes: [
      {
        path: '/vehicle',
        type: 'menu',
        name: '차량 목록',
        icon: 'remove ',
        component: VehicleList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/vehicleModel',
        type: 'menu',
        name: '차량 모델 목록',
        icon: 'remove ',
        component: VehicleModelList,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    type:"category",
    name:'회원 관리',
    icon:'group',
    subRoutes: [
      {
        path: '/customers',
        type: 'menu',
        name: '회원 목록',
        icon: 'remove',
        component: CustomerList,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/customers/:customerId',
    type: 'hidden',
    name: '회원 상세 정보',
    component: CustomerDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/noticeboard/:noticeId',
    type: 'hidden',
    name: '공지사항',
    component: NoticeBoardDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/noticeWrite',
    type: 'hidden',
    name: '공지사항 작성',
    component: NoticeWriter,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/noticeWrite/:noticeId',
    type: 'hidden',
    name: '공지사항 수정',
    component: NoticeWriter,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/terms/:typeId',
    type: 'hidden',
    name: '서비스 이용 약관',
    component: Terms,
    meta: {
      keepAlive: false
    }
  },
  {
    type:"category",
    name: '그룹 관리',
    icon:'library_books',
    subRoutes: [
      {
        path: '/group',
        type: 'menu',
        name: '그룹 목록',
        icon: 'remove',
        component: GroupList,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/group/:groupId',
    type: 'hidden',
    name: '그룹 상세 정보',
    component: GroupDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    type:"category",
    name:'시스템 설정',
    icon:'settings',
    subRoutes:[
      {
        path:'/noticeboard',
        type:"menu",
        name: '공지사항',
        icon:'remove',
        component:NoticeBoard,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/admin',
        type: 'menu',
        name: '관리자 계정 관리',
        icon: 'remove',
        component: AdminList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/role',
        type: 'menu',
        name: '관리자 권한 관리',
        icon: 'remove',
        component: RoleList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/center',
        type: 'menu',
        name: '센터 관리',
        icon: 'remove',
        component: CenterList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/lostItem',
        type: 'menu',
        name: '분실물 관리',
        icon: 'remove',
        component: LostItemList,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/hardware',
        type: 'menu',
        name: '하드웨어 관리',
        icon: 'remove',
        component: HardwareList,
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/termsBoard',
        type: 'menu',
        name: '약관 관리',
        icon: 'remove',
        component: TermsBoard,
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  {
    path: '/lostItem/:lostItemId',
    type: 'hidden',
    name: '분실물 상세 정보',
    component: LostItemDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/center/:centerId',
    type: 'hidden',
    name: '센터 상세 정보',
    component: CenterDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/vehicle/:vehicleId',
    type: 'hidden',
    name: '차량 상세 정보',
    component: VehicleDetail,
    meta: {
      keepAlive: false
    }
  },
];
export default routes;
